import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid } from "recharts";
import { QueueHistoryPoint } from "@/services/workerApi";

const SERIES: { key: keyof Omit<QueueHistoryPoint, "ts">; label: string; color: string }[] = [
  { key: "enrichment", label: "Candidats", color: "hsl(var(--chart-1))" },
  { key: "company_enrichment", label: "Entreprises", color: "hsl(var(--chart-2))" },
  { key: "school_enrichment", label: "Écoles", color: "hsl(var(--chart-3))" },
  { key: "company_jobs", label: "Offres", color: "hsl(var(--chart-4))" },
  { key: "search", label: "Recherche", color: "hsl(var(--chart-5))" },
];

const chartConfig: ChartConfig = Object.fromEntries(
  SERIES.map((s) => [s.key, { label: s.label, color: s.color }]),
);

function fmtTime(ts: number): string {
  return new Date(ts * 1000).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
}

// Tendance de profondeur des 5 files du pool dans le temps (snapshots reaper).
// Distingue un pic ponctuel d'une saturation chronique (famine durable).
export function QueueDepthHistoryChart({
  points,
  loading,
}: {
  points: QueueHistoryPoint[];
  loading?: boolean;
}) {
  if (loading && points.length === 0) {
    return <div className="text-sm text-muted-foreground py-8 text-center">Chargement...</div>;
  }
  if (points.length === 0) {
    return (
      <div className="text-sm text-muted-foreground py-8 text-center">
        Pas encore d'historique — les snapshots s'accumulent (1/min).
      </div>
    );
  }

  const data = points.map((p) => ({
    time: fmtTime(p.ts),
    enrichment: p.enrichment,
    company_enrichment: p.company_enrichment,
    school_enrichment: p.school_enrichment,
    company_jobs: p.company_jobs,
    search: p.search,
  }));

  return (
    <ChartContainer config={chartConfig} className="h-[280px] w-full">
      <AreaChart data={data}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="time" tickLine={false} axisLine={false} minTickGap={32} />
        <YAxis tickLine={false} axisLine={false} allowDecimals={false} />
        <ChartTooltip content={<ChartTooltipContent />} />
        {SERIES.map((s) => (
          <Area
            key={s.key}
            type="monotone"
            dataKey={s.key}
            stackId="1"
            fill={`var(--color-${s.key})`}
            stroke={`var(--color-${s.key})`}
            fillOpacity={0.4}
          />
        ))}
      </AreaChart>
    </ChartContainer>
  );
}
